import { combineReducers } from 'redux'
import cmsInfoSlice from './cmsInfo/cmsInfoSlice'
import posts from './posts/postsSlice'
import webTexts from './webTexts/webTextsReducer'

export default combineReducers({
	info: cmsInfoSlice,
	posts,
	webTexts,
})